import { StyleInputType } from '../inputType';

export const inputStylesDefinitions = {
  inputBackgroundColor: StyleInputType.COLOR,
  inputBorder: StyleInputType.BORDER,
  inputBorderRadius: StyleInputType.SIZE_WITH_UNIT,
  inputShadow: StyleInputType.SHADOW,
  inputFocus: StyleInputType.BOOLEAN,
  inputFocusBackgroundColor: StyleInputType.COLOR,
  inputFocusBorder: StyleInputType.BORDER,
  inputFocusBorderRadius: StyleInputType.SIZE_WITH_UNIT,
  inputFocusShadow: StyleInputType.SHADOW,
  inputFocusTextColor: StyleInputType.COLOR,
  inputFontFamily: StyleInputType.FONT_FAMILY,
  inputFontSize: StyleInputType.SIZE_WITH_UNIT,
  inputFontStyle: StyleInputType.FONT_STYLE,
  inputFontWeight: StyleInputType.FONT_WEIGHT,
  inputHover: StyleInputType.BOOLEAN,
  inputHoverBackgroundColor: StyleInputType.COLOR,
  inputHoverBorder: StyleInputType.BORDER,
  inputHoverBorderRadius: StyleInputType.SIZE_WITH_UNIT,
  inputHoverShadow: StyleInputType.SHADOW,
  inputHoverTextColor: StyleInputType.COLOR,
  inputLineHeight: StyleInputType.SIZE_WITH_UNIT,
  inputPlaceholderTextColor: StyleInputType.COLOR,
  inputSpacing: StyleInputType.SPACING,
  inputTextAlign: StyleInputType.TEXT_ALIGN,
  inputTextColor: StyleInputType.COLOR,
} satisfies Record<string, StyleInputType>;
